import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "crud-container" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "crud-table"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "pagination" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "dialog"
}
const _hoisted_13 = { class: "dialog-content" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "product-selection" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "product-list" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { style: {"display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { style: {"display":"flex","gap":"10px","flex-wrap":"wrap"} }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.authStore?.getRole === 'Admin')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateDialog && _ctx.openCreateDialog(...args))),
            class: "create-btn"
          }, "Create Invoice"))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedYear) = $event)),
        class: "year-dropdown"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableYears, (year) => {
          return (_openBlock(), _createElementBlock("option", {
            key: year,
            value: year
          }, _toDisplayString(year), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.selectedYear]
      ])
    ]),
    (_ctx.items.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Invoice ID"),
              _createElementVNode("th", null, "Invoice Date"),
              _createElementVNode("th", null, "Customer Name"),
              _createElementVNode("th", null, "Items"),
              _createElementVNode("th", null, "Amount payable"),
              _createElementVNode("th", null, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item._id
              }, [
                _createElementVNode("td", null, _toDisplayString(item._id), 1),
                _createElementVNode("td", null, _toDisplayString(item.billDate), 1),
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", {
                  innerHTML: item.products
                }, null, 8, _hoisted_5),
                _createElementVNode("td", null, _toDisplayString(item.amountPayable), 1),
                _createElementVNode("td", null, [
                  (_ctx.authStore?.getRole === 'Admin')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.openEditDialog(item)),
                        class: "edit-btn"
                      }, "Edit", 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.authStore?.getRole === 'Admin')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.deleteItem(item._id)),
                        class: "delete-btn"
                      }, "Delete", 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.printInvoice(item)),
                    class: "print-btn"
                  }, "Print", 8, _hoisted_8)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        disabled: _ctx.page === 1,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(_ctx.page - 1)))
      }, "Previous", 8, _hoisted_10),
      _createElementVNode("span", null, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(_ctx.totalPages), 1),
      _createElementVNode("button", {
        disabled: _ctx.page === _ctx.totalPages,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(_ctx.page + 1)))
      }, "Next", 8, _hoisted_11)
    ]),
    (_ctx.dialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.isEdit ? 'Edit Invoice' : 'Create Invoice'), 1),
            _createElementVNode("div", _hoisted_14, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { for: "company" }, "Select Company", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "company",
                disabled: _ctx.isEdit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemForm.companyId) = $event)),
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateAdminInfo(_ctx.itemForm.companyId)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: company._id,
                    value: company._id
                  }, _toDisplayString(company.name), 9, _hoisted_16))
                }), 128))
              ], 40, _hoisted_15), [
                [_vModelSelect, _ctx.itemForm.companyId]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { for: "billDate" }, "Bill Date", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "billDate",
                type: "date",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemForm.billDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.billDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { for: "user" }, "Select User", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "user",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.itemForm.userId) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: user._id,
                    value: user._id
                  }, _toDisplayString(user.name), 9, _hoisted_19))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.itemForm.userId]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { for: "product" }, "Add Product", -1)),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("select", {
                  id: "product",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedProduct) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: product._id,
                      value: product._id
                    }, " INR." + _toDisplayString(product.amount) + " - " + _toDisplayString(product.name), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedProduct]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedQuantity) = $event)),
                  placeholder: "Quantity",
                  min: "1"
                }, null, 512), [
                  [_vModelText, _ctx.selectedQuantity]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addProductToList && _ctx.addProductToList(...args)))
                }, "Add"),
                _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1))
              ]),
              _createElementVNode("ul", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemForm.items, (product, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createTextVNode(_toDisplayString(product.name) + " - " + _toDisplayString(product.quantity) + " ", 1),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.removeProductFromList(index))
                    }, "Remove", 8, _hoisted_24)
                  ]))
                }), 128))
              ])
            ]),
            _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_25, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { style: {"display":"flex","align-items":"center","gap":"10px"} }, " Tax Type: ", -1)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.itemForm.taxType) = $event)),
                    value: "GST"
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemForm.taxType]
                  ]),
                  _cache[29] || (_cache[29] = _createTextVNode(" GST"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.itemForm.taxType) = $event)),
                    value: "PAN"
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemForm.taxType]
                  ]),
                  _cache[30] || (_cache[30] = _createTextVNode(" PAN"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.itemForm.taxType) = $event)),
                    value: "None"
                  }, null, 512), [
                    [_vModelRadio, _ctx.itemForm.taxType]
                  ]),
                  _cache[31] || (_cache[31] = _createTextVNode(" NONE"))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[39] || (_cache[39] = _createElementVNode("label", null, "Additional Options:", -1)),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.itemForm.isTaxable) = $event)),
                    onChange: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateTotalAmount && _ctx.updateTotalAmount(...args)), ["stop"]))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.itemForm.isTaxable]
                  ]),
                  _cache[33] || (_cache[33] = _createTextVNode(" Is Taxable"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.itemForm.isProforma) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.itemForm.isProforma]
                  ]),
                  _cache[34] || (_cache[34] = _createTextVNode(" Is Proforma"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.itemForm.isPaid) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.itemForm.isPaid]
                  ]),
                  _cache[35] || (_cache[35] = _createTextVNode(" Is Paid"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.itemForm.addSignature) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.itemForm.addSignature]
                  ]),
                  _cache[36] || (_cache[36] = _createTextVNode(" Add Signature"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.itemForm.isConsolidated) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.itemForm.isConsolidated]
                  ]),
                  _cache[37] || (_cache[37] = _createTextVNode(" Is Consolidated"))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.itemForm.isNotes) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.itemForm.isNotes]
                  ]),
                  _cache[38] || (_cache[38] = _createTextVNode(" Notes"))
                ])
              ])
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", null, "Total Amount: INR. " + _toDisplayString(_ctx.itemForm.total), 1),
              (_ctx.itemForm.isTaxable)
                ? (_openBlock(), _createElementBlock("label", _hoisted_30, "Tax Amount (18%): INR. " + _toDisplayString(_ctx.itemForm.taxAmount), 1))
                : _createCommentVNode("", true),
              _createElementVNode("label", null, "Amount Payable: INR. " + _toDisplayString(_ctx.itemForm.amountPayable), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.dialog = false)),
                class: "cancel-btn"
              }, "Cancel"),
              _createElementVNode("button", {
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.saveItem && _ctx.saveItem(...args))),
                class: "save-btn"
              }, _toDisplayString(_ctx.isEdit ? 'Save' : 'Create'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}